import axios from "axios";
import VueCookie from "vue-cookie";
import {HttpRequest,HttpMethod,axiosInstance} from "./http";

class MemberProvider extends HttpRequest {

	// CRUD Member
	MemberCreate(params){
		return this.request(HttpMethod.Post,`/api/v2/member`,params );
	}

	MemberList(params){
		return this.request(HttpMethod.Get,`/api/v2/member`,params );
	}

	MemberGet(id){
		return this.request(HttpMethod.Get,`/api/v2/member/${id}`);
	}

	MemberUpdate(id,params){
		return this.request(HttpMethod.Put,`/api/v2/member/${id}`,params );
	}

	MemberDelete(id){
		return this.request(HttpMethod.Delete,`/api/v2/member/${id}`);
	}

	// Member Coupons
	MemberGetCoupons(id, params){
		return this.request(HttpMethod.Get,`/api/v2/member/${id}/coupons`,params );
	}

	// Member Coupon Management
	MemberCouponList(params){
		return this.request(HttpMethod.Get,`/api/v2/member-coupons`,params );
	}

	MemberCouponAssign(params){
		return this.request(HttpMethod.Post,`/api/v2/member-coupons/assign`,params );
	}

	MemberCouponRemove(id){
		return this.request(HttpMethod.Delete,`/api/v2/member-coupons/${id}`);
	}

	// Member Management (BO admin / customer support)
	AdminList(params)        { return this.request(HttpMethod.Get,  `/api/v3/members`, params); }
	AdminExport(params)      {
		// Bypass HttpRequest so we can ask axios for a binary blob — the
		// shared interceptors are bound to that axios instance via cookies.
		return axios.get(process.env.VUE_APP_API_BASE_URL + `/api/v3/members/export`, {
			params,
			responseType: "blob",
			headers: { Authorization: "Bearer " + (VueCookie.get("token") || "") },
			timeout: 600000,
		});
	}
	AdminCreate(payload)     { return this.request(HttpMethod.Post, `/api/v3/members`, payload); }
	AdminGet(id)             { return this.request(HttpMethod.Get,  `/api/v3/members/${id}`); }
	AdminUpdate(id, payload) { return this.request(HttpMethod.Put,  `/api/v3/members/${id}`, payload); }
	AdminAddresses(id)       { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/addresses`); }
	AdminAddressCreate(id, payload)         { return this.request(HttpMethod.Post,   `/api/v3/members/${id}/addresses`, payload); }
	AdminAddressUpdate(id, addrID, payload) { return this.request(HttpMethod.Put,    `/api/v3/members/${id}/addresses/${addrID}`, payload); }
	AdminAddressDelete(id, addrID)          { return this.request(HttpMethod.Delete, `/api/v3/members/${id}/addresses/${addrID}`); }
	AdminPoints(id, params)  { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/points`, params); }
	AdminCoupons(id)         { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/coupons`); }
	AdminRedemptions(id)     { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/redemptions`); }
	AdminNotifications(id)   { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/notifications`); }
	AdminSessions(id)        { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/sessions`); }
	AdminEvents(id, params)  { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/events`, params); }
	AdminPDPA(id)            { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/pdpa`); }
	AdminLegacyLink(id)      { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/legacy-link`); }
	AdminOrders(id, params)  { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/orders`, params); }
	AdminOrderDetail(id, orderID) { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/orders/${orderID}`); }
	AdminCalculateSpending(payload) { return this.request(HttpMethod.Post, `/api/v3/members/calculate-spending`, payload); }
	AdminCalculateSpendingStatus() { return this.request(HttpMethod.Get,  `/api/v3/members/calculate-spending/status`); }

	// Coin ledger (coin D3-3 / D3-4 — bo-fn#294, bo-api coin D3).
	// AdminCoins mirrors AdminPoints: { coin_balance, lifetime_coins_earned, rows }.
	// AdminCoinsAdjust returns { coin_balance }, or 400 `bad_adjust` / 409
	// `insufficient` with the code in `Msg` — never clamped server-side, so the
	// caller must show the rejection (see src/utils/memberCoins.js).
	AdminCoins(id, params)        { return this.request(HttpMethod.Get,  `/api/v3/members/${id}/coins`, params); }
	AdminCoinsAdjust(id, payload) { return this.request(HttpMethod.Post, `/api/v3/members/${id}/coins/adjust`, payload); }
	AdminCoinsLiability(params)   { return this.request(HttpMethod.Get,  `/api/v3/members/coins/liability`, params); }
	// xlsx bytes. Must go through axiosInstance directly: HttpRequest.request
	// takes (method, url, payload) only, so a 4th { responseType } argument is
	// dropped and the download arrives decoded as text (the corrupt-export bug
	// guarded by tests/unit/resourceBlobExports.spec.js).
	AdminCoinsLiabilityExport(params) {
		return axiosInstance.get(`/api/v3/members/coins/liability/export`, {
			params,
			responseType: "blob",
		});
	}

	// COD-rejection anti-abuse guard (issue #179)
	CodRejectionsList()          { return this.request(HttpMethod.Get,  `/api/v1/bo/cod-rejections`); }
	CodRejectionsClear(phone)    { return this.request(HttpMethod.Post, `/api/v1/bo/cod-rejections/clear`, { phone }); }
}

export default MemberProvider